module.exports = function getResource(label, vars = []) {
    let resources = {
        pickupNotOffered: ' –Le ramassage n’est pas offert',
        openUntil: `Ouvert jusqu’à ${vars[0]}`,
        closed: 'Fermé',
        milesAway: ' kilomètres de distance',
        inStock: 'En stock',
        outOfStock: 'Rupture de stock',
        limitedStock: 'Quantités limitées',
        payInStore: 'Payer en magasin',
        payOnline: 'Payer en ligne'
    };

    return resources[label];
};
